import Skeleton from "react-loading-skeleton";
import "./styles.scss";

const NoticeCardSkeleton = ({ containerStyle = {} }) => {
  return (
    <div
      className="notice-card-skeleton-container"
      style={{ ...containerStyle }}
    >
      <div className="card-skeleton-inner">
        <Skeleton
          count={2}
          height={18}
          baseColor="#FFFFFF"
          highlightColor="#E3E8EF"
          className="card-skeleton-lines"
        />
      </div>
    </div>
  );
};

export default NoticeCardSkeleton;
